import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
    selector: 'ui-pagination',
    template: `
        <div class="form-inline">
            <div class="form-group">
                <label for="perPage" class="d-none d-md-inline px-2">
                    Results per page:
                </label>
                <select id="perPage" class="form-control form-control-sm" (change)="changePerPage($event)">
                    @for (option of perPageOptions; track option) {
                        <option [value]="option" [selected]="option === perPage">{{ option }}</option>
                    }
                </select>
            </div>
            @if (pagesCount > 1) {
                <div class="btn-group btn-group-sm ml-2" role="group" aria-label="Pagination">
                    <button class="btn btn-secondary" title="Previous Page" [disabled]="currentPage <= 1" (click)="changePage(currentPage - 1)">
                        <i class="fa fa-caret-left"></i>
                    </button>
                    <button class="btn btn-secondary" [class.active]="currentPage === 1" (click)="changePage(1)">
                        1
                    </button>
                    @if (pageCutLow > 2) {
                        <button class="btn btn-secondary" (click)="changePage(pageCutLow - 2)">
                            ...
                        </button>
                    }
                    @for (page of pages; track page) {
                        <button class="btn btn-secondary" [class.active]="currentPage === page" (click)="changePage(page)">
                            {{ page }}
                        </button>
                    }
                    @if (pagesCount - pageCutHigh > 2) {
                        <button class="btn btn-secondary" (click)="changePage(pageCutHigh + 2)">
                            ...
                        </button>
                    }
                    <button class="btn btn-secondary" [class.active]="currentPage === pagesCount" (click)="changePage(pagesCount)">
                        {{ pagesCount }}
                    </button>
                    <button class="btn btn-secondary" title="Next Page" [disabled]="currentPage >= pagesCount" (click)="changePage(currentPage + 1)">
                        <i class="fa fa-caret-right"></i>
                    </button>
                </div>
            }
        </div>
    `,
})
export class PaginationComponent {

    @Input({ required: true }) currentPage = 1;

    @Output() currentPageChange = new EventEmitter<number>();

    @Input({ required: true }) itemsCount: number;

    @Input({ required: true }) perPage: number;

    @Output() perPageChange = new EventEmitter<number>();

    @Input({ required: true }) perPageOptions: number[];

    get pagesCount() {
        return Math.ceil(this.itemsCount / this.perPage);
    }

    get pages() {
        const start = this.pageCutLow;
        const stop = this.pageCutHigh;
        return Array.from({ length: stop - start + 1 }, (_, i) => start + i);
    }

    get pageCutLow() {
        return this.pagesCount < 6 || this.currentPage <= 4 ? 2 : Math.min(this.currentPage - 1, this.pagesCount - 3);
    }

    get pageCutHigh() {
        return this.pagesCount < 6 || this.pagesCount - this.currentPage <= 3 ? this.pagesCount - 1 : Math.max(this.currentPage + 1, 4);
    }

    changePage(page: number) {
        this.currentPageChange.emit(page);
    }

    changePerPage(event: Event) {
        event.preventDefault();
        const itemIndex = Math.min(this.perPage * (this.currentPage - 1), this.itemsCount);
        const newPerPage = parseInt((event.target as HTMLSelectElement).value);
        const newCurrentPage = Math.floor(itemIndex / newPerPage) + 1;
        this.perPageChange.emit(newPerPage);
        this.currentPageChange.emit(newCurrentPage);
    }
}
